import { Base } from '../base-component';
import './timeline-vertical.component.scss';
import * as Swiper from 'swiper/dist/js/swiper.js';
import SliderYears from '../slider/slider.component';
import SliderContent from '../slider/slider.component';

export class TimelineVertical extends Base {

	yearsSlider: any;
	yearsSliderContainer: any;
	yearsSliderConfig: any;
	yearsSlides: any;

	contentSlider: any;
	contentSliderContainer: any;
	contentSliderConfig: any;

	constructor(element: Element){

		super(element);

	}

	init(){

		// this.yearsSlider = new Swiper('.timeline-vertical__years', {
		// 	slidesPerView: 18,
		// 	direction: 'vertical',
		// 	spaceBetween: 0,
		// 	initialSlide: 0,
		// 	freeMode: false,
		// });

		this.yearsSlider = new Swiper('.timeline-vertical__years', {
			slidesPerView: 20,
			direction: 'vertical',
			centeredSlides: true,
			spaceBetween: 0,
			initialSlide: 0,
			freeMode: false,
			hashNavigation: {
				watchState: true,
			},
		});

		this.contentSlider = new Swiper('.timeline-vertical__content', {
			slidesPerView: 'auto',
			direction: 'vertical',
			spaceBetween: 0,
			initialSlide: 0,
			freeMode: true,
			mousewheel: {
				invert: false,
			},
		});

        this.yearsSlider.on('slideChange', () => {
            this.contentSlider.slideTo(this.yearsSlider.realIndex);
		});
		
        this.contentSlider.on('slideChange', () => {
            this.yearsSlider.slideTo(this.contentSlider.realIndex);
		});
		
		this.yearsSlides = Array.from(this.element.querySelectorAll('.timeline-vertical__years .swiper-slide'));

	}

	bindEvents() {

		this.yearsSlides.map((item) => item.addEventListener('click', (event) => {
			let element;
			if(event.currentTarget) {
				element = event.currentTarget;
			}else{
				element = event.target;
			}
			let container = element.querySelector('.timeline-vertical__years--year');
			let getIndex = container.getAttribute('data-index');
			this.contentSlider.slideTo(getIndex - 1);
			this.yearsSlider.slideTo(getIndex - 1);
		}));

	}

}


// WEBPACK FOOTER //
// ./components/timeline-vertical/timeline-vertical.component.ts